define('commons/install-data-config-factory',['commons/install-data-config'], function(InstallDataConfig) {
    return function(model) {
        var config = new InstallDataConfig({
            tree: '#config'
        });
        var tests = new InstallDataConfig({
            tree: '#tests',
            onlyTest: true
        });
        var fancyJson = InstallDataConfig.toFancyFormat(model.data);
        config.buildTree(fancyJson.config, false);
        tests.buildTree(fancyJson.tests, false);
    };
});
